import React from "react";
import {MapContainer, Marker, Polygon, Rectangle, TileLayer, Tooltip} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import {Stack} from "@mui/material";
import {dashboardHelper} from "../utils/dashboardHelper.js";
import AutoFitBounds from "../../layout/map/AutoFitBounds.js";
import './DashboardMap.css'

const DashboardMap = ({mode, clientsData, laveusesData = [], onTourneeClick, mapRef}) => {
    const [autoFitDone, setAutoFitDone] = React.useState(false);
    const polygons = dashboardHelper.getTourneePolygons(clientsData, mode);

    return (
        <Stack sx={{width: "100%"}}>
            <MapContainer
                center={[46.6, 2.2]} // centre France par défaut
                zoom={6}
                ref={mapRef}
                style={{height: "calc(100vh - 128px - 3rem)", width: "100%"}}
            >
                <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {polygons.map((polygon, idx) => {
                    return (
                        <Polygon
                            key={idx}
                            positions={polygon.coordinates}
                            pathOptions={{color: polygon.color, weight: 2, fillOpacity: 0.2}}
                            eventHandlers={{
                                click: () => onTourneeClick(polygon.tournee)
                            }}
                        />
                    )
                })}


                <AutoFitBounds polygons={polygons} disabled={autoFitDone} onFit={() => setAutoFitDone(true)} />
            </MapContainer>
        </Stack>
    );
};

export default DashboardMap;
